import React from "react";
import Head from "next/head";

function addProductJsonLd(slug, title, metaDescription, seoTitle, seoImageUrl) {
  return {
    __html: `{
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "${seoTitle}",
      "address": {
        "@type": "PostalAddress",
        "postalCode": "07022",
        "streetAddress": "1 Broad Ave, Unit #4",
        "addressCountry": "US",
        "addressRegion": "NJ",
        "addressLocality": "Fairview"
      },
      "telephone": [
        "+1-201-308-3212",
        "+1-201-613-5137"
      ],
      "url": "https://techcelerant.com/services/${slug}",
      "image": "${seoImageUrl}",
      "description": "${metaDescription}",
      "serviceArea": {
        "@type": "Country",
        "name": "USA"
      },
      "@id": "https://techcelerant.com/services/${slug}",
      "sameAs": [
        "https://facebook.com/techcelerant",
        "https://twitter.com/techcelerant",
        "https://linkedin.com/company/techcelerant"
      ]
    }
  `,
  };
}

// import { ArticleJsonLd, NextSeo } from 'next-seo';
// import { urlFor } from '../../../lib/client';

const SeoComponent = ({ data }) => {
  const { title, slug, metaDescription, seoTitle, seo_image } = data;

  const title_message = title ? title : "";

  const message = `${title_message}`;

  const seoImageUrl = seo_image;

  return (
    <>
      <Head>
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href={`https://techcelerant.com/services/${slug}`}
        />
        <title>{`${message}`}</title>

        <meta name="description" content={metaDescription} />
        <link rel="apple-touch-icon" href="apple-touch-icon.png" />
        <link rel="icon" type="image/x-icon" href="/favicon.ico" />

        <meta name="viewport" content="width=device-width, initial-scale=1" />
        {slug === "web-development" && (<meta name="keywords" content="Custom Website Development, Professional Website Designers, Affordable Web Development Services, E-commerce Website Developers, Small Business Website Design, Responsive Web Design Agency, Creative Web Developers, Corporate Website Development, WordPress Website Designers, Mobile App Development Services, SEO-Friendly Website Design, Graphic Design for Websites, UI/UX Design Experts, Landing Page Optimization Services, Shopify Website Development, Custom Web Application Development, Restaurant Website Designers, Real Estate Web Developers, Fashion Website Design Services, Healthcare Website Development, Legal Website Designers, Financial Services Website Developers, Educational Website Design, Travel Website Development Agency, Nonprofit Website Design Services, Restaurant Website Designers, Real Estate Web Developers, Fashion Website Design Services, Healthcare Website Development, Legal Website Designers, Financial Services Website Developers, Educational Website Design, Travel Website Development Agency, Nonprofit Website Design Services, E-commerce Website Developers, Medical Website Design Services, Healthcare Web Developers, Telemedicine Website Development"/>)}
        {slug === "graphic-designing" && (<meta name="keywords" content="design service near me, Logo design service online, Logo design services in usa, Logo design services, Professional logo design services near me, Graphic design services to offer, Graphic design agency services, Graphic design services affordable, Graphic design services brochure, Graphic design services and prices, Logo design services available, Best logo design services, Logo design best companiesLogo, Logo design branding services, Graphic design service charges, Graphic design services company, Graphic design services contract, Graphic design services cost, Graphic design services detail, Digital services logo design, Electric services logo design, E services logo design, Logo design services near me, Logo design services, Logo design services for company, Logo design services fee, Logo design services for cheap, Graphic design services for small businesses, Graphic design services fiver, Graphic design services flyer, Best logo design companies for startup, Logo design financial services, Creative graphic design services flyer, Logo design for catering services, Garden services logo design, Logo design services hourly rate, Graphic design services hourly rate, Handyman services logo design, Health services logo design, Home services logo design, Logo design services los angeles, Logo design laundry design, Logo design per hour, Graphic design services market, Graphic design services manufacturers, 3d logo design services, Graphic design services poster, Graphic design services needed, Graphic design services name, Logo design company name, Logo design services offer,
        Graphic design services offer,
        Logo design of companies,
        Website graphic design services online,
        Top online logo design services,
        Logo design service providers,
        Logo design service phone numbers,
        Graphic design services packages,
        Graphic design services page,
Graphic design services post,
 Graphic design services page,
Graphic design service sale,
Graphic design services studio,
Graphic design services sites,
Best rated logo design services, 
Logo design services san diego,
Logo design services in california,
Graphic design services in california,
Graphic design services in ohio,
Graphic design services in new york,
Logo design companies in usa,
Graphic design services near me,
Logo design services website,
Graphic design services website,
Web design logo services,
Logo design service,
Graphic design service ny,
Auto Repair Shop Logo Designers,
Car Service Center Logo Design Services,
Brake Repair Shop Logo Designers,
Tire Service Logo Design Services,
Engine Repair Logo Designers,
Transmission Repair Logo Design Services,
Suspension Service Logo Designers,
Oil Change Logo Design Services,
Electrical Repair Shop Logo Designers,
Diagnostic Service Logo Design Services,
Trucking Company Logo Designers,
Freight Transport Logo Design Services,
Truck Repair Shop Logo Designers,
Trailer Service Logo Design Services,
Logistics Company Logo Designers,
Moving Company Logo Design Services,
Truck Accessories Logo Designers,
Fleet Management Logo Design Services,
Cargo Transport Logo Designers,
Heavy Equipment Logo Design Services,
Express Car Wash Logo Designers,
Full-Service Car Wash Logo Design Services,
Hand Car Wash Logo Designers,
Automatic Car Wash Logo Design Services,
Mobile Car Wash Logo Designers,
Self-Service Car Wash Logo Design Services,
Eco-Friendly Car Wash Logo Designers,
Interior Car Detailing Logo Design Services,
Exterior Car Detailing Logo Designers,
Truck Wash Logo Design Services,
Residential Cleaning Logo Designers,
Commercial Cleaning Logo Design Services,
Janitorial Service Logo Designers,
Carpet Cleaning Company Logo Design,
Window Cleaning Logo Design Services,
Maid Service Logo Designers,
Office Cleaning Logo Design Services,
Deep Cleaning Company Logo Design,
Eco-Friendly Cleaning Logo Designers,
Disinfection Service Logo Design Services
        "/>)}

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={addProductJsonLd(
            slug,
            title,
            metaDescription,
            seoTitle,
            seoImageUrl,
          )}
        />
      </Head>
    </>
  );
};

export default SeoComponent;
